module.exports = __webpack_public_path__ + "img/ok.43b826eb.png";